import { IStep } from "../../models/step";

export enum StepsReducerActionTypes {
  SetToDone = "SET_TO_DONE",
  ResetDoneOnBack = " RESET_DONE_ON_BACK",
  ResetDoneOnJump = "RESET_DONE_ON_JUMP",
}

interface IStepsActionSet {
  type: StepsReducerActionTypes;
  value: number;
}

export type IStepsAction = IStepsActionSet;

export const stepsReducer = (state: IStep[], action: IStepsAction) => {
  switch (action.type) {
    case StepsReducerActionTypes.SetToDone: {
      const newSteps = [...state];
      newSteps[action.value - 1].done = true;
      return newSteps;
    }
    case StepsReducerActionTypes.ResetDoneOnBack: {
      const newSteps = [...state];
      newSteps[action.value - 1].done = false;
      return newSteps;
    }
    case StepsReducerActionTypes.ResetDoneOnJump: {
      const newSteps = [...state];
      for (let i = action.value - 1; i < newSteps.length; i++) {
        newSteps[i].done = false;
      }
      return newSteps;
    }
    default:
      return state;
  }
};
